var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      staticClass: "mb-2",
      attrs: {
        width: 2285,
        height: 42,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "42", width: "2285", y: "0", x: "0", rx: "5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }